import type mapboxgl from 'mapbox-gl';
import type { MapLayerMouseEvent } from 'mapbox-gl';
import { CLUSTER_SOURCE_ID } from '../hooks/use-overview-points-cluster.constants';
import { CURSOR_DEFAULT, CURSOR_POINTER } from '../hooks/use-overview-points-popup.constants';
import { DATA_SOURCE_POINTS } from '../hooks/use-render-map-disease-risk-field';

type HoverStateSetter = (map: mapboxgl.Map, id: string | number, hover: boolean) => void;

export const setFeatureHoverState: HoverStateSetter = (map, featureId, hover) => {
  map.setFeatureState({ source: DATA_SOURCE_POINTS, id: featureId }, { hover });
  map.setFeatureState({ source: CLUSTER_SOURCE_ID, id: featureId }, { hover });
};

export const createHoverHandlers = (
  map: mapboxgl.Map,
  ref: React.MutableRefObject<string | number | null>,
  setHoverState: HoverStateSetter
) => ({
  onMouseMove: (e: MapLayerMouseEvent) => {
    map.getCanvas().style.cursor = CURSOR_POINTER;

    const feature = e.features?.[0];
    if (!feature?.id) return;

    if (ref.current !== null && ref.current !== feature.id) {
      setHoverState(map, ref.current, false);
    }

    ref.current = feature.id;
    setHoverState(map, feature.id, true);
  },
  onMouseLeave: () => {
    map.getCanvas().style.cursor = CURSOR_DEFAULT;

    if (ref.current !== null) {
      setHoverState(map, ref.current, false);
      ref.current = null;
    }
  }
});
